import { render } from "./reksadanaCampuran.vue?vue&type=template&id=eb4bb71c&scoped=true"
import script from "./reksadanaCampuran.vue?vue&type=script&lang=js"
export * from "./reksadanaCampuran.vue?vue&type=script&lang=js"

import "./reksadanaCampuran.vue?vue&type=style&index=0&id=eb4bb71c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb4bb71c"]])

export default __exports__